export default __webpack_public_path__ + "static/Khaled Al-Amoodi - Resume-e846e228c600aee4df524f2a6704c177.pdf";